import React from "react";

import { Image } from "~/components/image/component";
import { PaymentMethodContainer } from "~/components/payment-method/styled";
import { prepareTextAttribute } from "~/helpers/prepare-text-attribute";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { PAYMENT_METHOD_CLASSES } from "../payment-method/constants";

import { imageTemplates } from "./constants";

export interface PaymentMethodProps {
  image?: {
    url?: string | null;
    sourceUrl?: string | null;
    alternateText?: string | null;
  };
}

export const PaymentMethodWithImage: React.FC<PaymentMethodProps> = ({ image }) => {
  const { url, sourceUrl, alternateText } = image ?? {};

  const isAmplienceImage = !!sourceUrl;
  const imageSrc = isAmplienceImage ? sourceUrl : url;

  return (
    <PaymentMethodContainer {...getTestAutomationProps("payment-method")}>
      <Image
        src={imageSrc ?? undefined}
        alt={prepareTextAttribute(alternateText, true)}
        className={PAYMENT_METHOD_CLASSES.image}
        imageTemplates={isAmplienceImage ? imageTemplates : undefined}
      />
    </PaymentMethodContainer>
  );
};
